const REFLECTIONS_KEY = "kalki_reflections_v1";
const RECENT_KEY = "kalki_recent_chat_v1";
const MAX_REFLECTIONS = 5;
const MAX_RECENT = 30;

// ---- Reflections ----
export function getReflections() {
  try {
    const raw = localStorage.getItem(REFLECTIONS_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function saveReflection(reflection) {
  const list = getReflections();
  const filtered = list.filter(
    (r) => !(r.question === reflection.question && (r.takeaway === reflection.takeaway || r.action === reflection.takeaway))
  );
  filtered.unshift(reflection);
  const trimmed = filtered.slice(0, MAX_REFLECTIONS);
  localStorage.setItem(REFLECTIONS_KEY, JSON.stringify(trimmed));
  return trimmed;
}

export function isReflectionSaved(reflection) {
  const list = getReflections();
  return list.some((r) => r.question === reflection.question && r.takeaway === reflection.takeaway);
}

// ---- Recent chat (last N messages) ----
export function loadRecentMessages() {
  try {
    const raw = localStorage.getItem(RECENT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

export function pushRecentMessage(messages) {
  try {
    const trimmed = messages.slice(-MAX_RECENT);
    localStorage.setItem(RECENT_KEY, JSON.stringify(trimmed));
  } catch {
    // ignore quota errors
  }
}

export function clearRecentMessages() {
  localStorage.removeItem(RECENT_KEY);
}
